import { useReducer } from 'react';
import { uploadProjectRequest } from '../../api';
import reducer from './reducer';
import initialState from './initialState';
import * as actionTypes from './actionTypes';

const actionCreators = {
  uploadProjectRequest: () => ({
    type: actionTypes.UPLOAD_PROJECT_REQUEST,
  }),
  uploadProjectSuccess: () => ({ type: actionTypes.UPLOAD_PROJECT_SUCCESS }),
  uploadProjectFailure: (error: string) => ({
    type: actionTypes.UPLOAD_PROJECT_FAILURE,
    payload: { error },
  }),
};

export default () => {
  const [uploadProjectState, dispatch] = useReducer(reducer, initialState);

  type UploadProjectArgs = {
    environmentId: string;
    password: string;
    applicationName: string;
    description?: string;
  };

  const uploadProject = async ({
    environmentId,
    password,
    applicationName,
    description,
  }: UploadProjectArgs) => {
    try {
      dispatch(actionCreators.uploadProjectRequest());

      await uploadProjectRequest(environmentId, {
        password,
        app_name: applicationName,
        description: description || undefined,
      });

      dispatch(actionCreators.uploadProjectSuccess());
    } catch (error) {
      dispatch(actionCreators.uploadProjectFailure(error));
    }
  };

  return {
    uploadProjectState,
    uploadProject,
  };
};
